import React, { Component } from 'react'

class MenuItemCard extends Component {
    getBadgeClass(categoryName) {
        if (categoryName.indexOf('芋') !== -1 || categoryName.indexOf('紫') !== -1) return 'badge_taro';
        if (categoryName.indexOf('紅豆') !== -1) return 'badge_redbean';
        if (categoryName.indexOf('綠豆') !== -1 || categoryName.indexOf('抹茶') !== -1) return 'badge_mung';
        return 'badge_default';
    }

    render() {
        var item = this.props.item;
        var category = this.props.category || '';

        return (
            <article className="menu_card">
                <div className="menu_card_img_wrap">
                    {item.more_info.img && (
                        <img src={item.more_info.img} alt={item.name} />
                    )}
                    <span className={"menu_card_cat_badge " + this.getBadgeClass(category)}>
                        {category}
                    </span>
                </div>
                <div className="menu_card_body">
                    <h3 className="menu_card_name">{item.name}</h3>
                    {item.more_info.desc && (
                        <p className="menu_card_desc">{item.more_info.desc}</p>
                    )}
                    <div className="menu_card_footer">
                        {item.more_info.price && (
                            <span className="menu_card_price">{item.more_info.price}</span>
                        )}
                        <a
                            href="https://order.doday.com.tw"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="menu_card_order_link"
                        >
                            訂購
                        </a>
                    </div>
                </div>
            </article>
        );
    }
}

export default MenuItemCard;
